//noScroll
class Facility {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let carousel = new Swiper('.js-carousel', {
      autoplay: {
        delay: 2500, // 2500ミリ秒 = 2.5秒後に次のスライドへ
        disableOnInteraction: false, // ユーザーの操作後も自動再生を継続
      },
      slidesPerView: 1.3,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 500,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 2.7,
        }
      }
    });

    var voiceSwiper = new Swiper('.voiceSwiper', {
      slidesPerView: 1.2,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        }
      }
    });

    const heading = document.querySelector('.js-header');

    // オプション指定
    const options = {
      threshold: 0 // 指定範囲は0 〜 1
    };

    // 実行
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.intersectionRatio == 0) {
          $('.facility-header__hum').addClass('is-scroll');
        } else {
          $('.facility-header__hum').removeClass('is-scroll');
        }
      });
    }, options);

    observer.observe(heading);

    const mediaQuery = window.matchMedia('(min-width: 768px)')
    if (mediaQuery.matches) {
      gsap.to('.s-point', { // 動かしたい要素
        scrollTrigger: {
          trigger: '.s-point', // 要素がビューポートに入ったときにアニメーション開始
          start: 'center center', // アニメーション開始位置
          end: 'center center-=2400px', // アニメーション終了位置
          scrub: 1,
          pin: true,
          onUpdate: function(self) {
            if(600 > parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(1).removeClass('is-active');
            } else if(600 < parseInt(window.pageYOffset - self.start) && 1200 > parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(1).addClass('is-active');
              $('.s-point__card').eq(2).removeClass('is-active');
            } else if(1200 < parseInt(window.pageYOffset - self.start) && 1800 > parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(2).addClass('is-active');
              $('.s-point__card').eq(3).removeClass('is-active');
            } else if(1800 < parseInt(window.pageYOffset - self.start)) {
              $('.s-point__card').eq(1).addClass('is-active');
              $('.s-point__card').eq(2).addClass('is-active');
              $('.s-point__card').eq(3).addClass('is-active');
            }
          }
        }
      });
    }
  }
}

//noScroll
class FrontPage {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      // SPサイズ 

      const futureSwiper = new Swiper('.future-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 14,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 1,
        speed: 300, 
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          renderBullet: function (index, className) {
            // ページネーションに番号を表示
            return '<div class="' + className + '">' + ('0' + (index + 1)) + "</div>";
          },
        },
      });
      
      const cards = document.querySelectorAll(".js-card__front");
      const overlay = document.querySelector(".overlay");
      const futureSwipers = document.querySelector(".s-future__spSwiper");
      const closeButton = document.querySelector(".s-future__spSwiper-close");
      const swipersSlides = document.querySelectorAll(".s-future__spSwiper-slide");
      
      cards.forEach((card) => {
        card.addEventListener('click', () => {
          overlay.classList.add("is-active");
          const dataIndex = card.dataset.slideIndex;
          futureSwipers.classList.add("is-active");
      
          swipersSlides.forEach((slide, index) => {
            const dataModal = slide.dataset.modal;
            if (dataModal === dataIndex) {
              futureSwiper.slideTo(index);
              futureSwiper.update();
              overlay.classList.add("is-active");
            } else {
              slide.classList.remove("swiper-slide-active");
            }
          });
      
        });
      });
      
      // 閉じるボタンの挙動
      closeButton.addEventListener('click', function () {
        overlay.classList.remove("is-active");
        futureSwipers.classList.remove("is-active");
      });

      overlay.addEventListener('click', function () {
        overlay.classList.remove("is-active");
        futureSwipers.classList.remove("is-active");
      });

    } else {
      // PCサイズ

      // カード 回転
      // ======================================================
      const cards = document.querySelectorAll('.js-card');
        function transition() {
          if (this.classList.contains('is-active')) {
            this.classList.remove('is-active')
          } else {
            this.classList.add('is-active');
          }
        }
        cards.forEach(card => card.addEventListener('click', transition));
      }
    
      var voiceSwiper = new Swiper('.voiceSwiper', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 1,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          //767px以上の場合
          767: {
            slidesPerView: 2.5,
            spaceBetween: 16,
          }
        }
      });

    // var mySwiper = new Swiper('.swiper-container', {
    //   loop: true,
    //   slidesPerView: 'auto',
    //   speed: 30000,
    //   allowTouchMove: false,
    //   autoplay: {
    //     delay: 0,
    //     reverseDirection: true,
    //   },
    // });

    // 300pxスクロールしたらheader-hideを付与し、top-headerを削除
    window.addEventListener('scroll', () => {
      const header = document.querySelector('.l-header');
      const topHeader = document.querySelector('.top-header');
      if (window.scrollY > 300) {
        header.classList.add('header-hide');
        header.classList.remove('top-header');
      } else {
        header.classList.remove('header-hide');
        if (!topHeader) {
          header.classList.add('top-header');
        }
      }
    });

    window.addEventListener('scroll', () => {
      const header = document.querySelector('.l-header');
      const sMvSection = document.querySelector('.s-mv');
  
      if (sMvSection) {
          const sMvSectionBottom = sMvSection.offsetTop + sMvSection.offsetHeight;
          if (window.scrollY > sMvSectionBottom) {
              header.classList.add('header-display');
  
              // header-displayクラスがある場合
              const megaMenu = document.querySelector(".js-megaMenu");
              const megaMenuClick = document.querySelectorAll(".js-megaMenu-click");
              megaMenu.classList.remove('is-topPage');
              megaMenuClick.forEach(element => {
                  element.classList.remove('is-topPage');
              });
          } else {
              header.classList.remove('header-display');
  
              // header-displayクラスがない場合
              const megaMenu = document.querySelector(".js-megaMenu");
              const megaMenuClick = document.querySelectorAll(".js-megaMenu-click");
              megaMenu.classList.add('is-topPage');
              megaMenuClick.forEach(element => {
                  element.classList.add('is-topPage');
              });
          }
      }
  });
  


    // if (document.querySelector('.header-display')) {
    //     // header-displayクラスがある場合
    //     megaMenu.classList.remove('is-topPage');
    //     megaMenuClick.forEach(el => {
    //         el.classList.remove('is-topPage');
    //     });
    // } else {
    //     // header-displayクラスがない場合
    //     megaMenu.classList.add('is-topPage');
    //     megaMenuClick.forEach(el => {
    //         el.classList.add('is-topPage');
    //     });
    // }
  }
}

// globals
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(document).ready(function() {
      $(".c-flex__spMenu").addClass("is-color");
      $(".c-flex__spMenu-archive").addClass("is-color");
      $(".c-flex__spMenu-column").addClass("is-color");
    
      $(".c-qa__q, .c-flex__spMenu, .c-flex__spMenu-archive, .c-flex__spMenu-column").on('click', function() {
        $(this).toggleClass('is-active').next().slideToggle();
      });
    
      if (window.innerWidth <= 768) {
        $(".c-flex__menu-item").on('click', function() {
          var newText = $(this).text();
          $(".c-flex__spMenu").text(newText).addClass("is-color");
          $(".c-flex__spMenu-archive").text(newText).addClass("is-color");
          $(".c-flex__menu").fadeToggle();
        });
      }
    });
  }
}
class CampaignSwiper {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    var campaignSwiper;

    function initSwiper() {
      campaignSwiper = new Swiper('.campaign-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        loopAdditionalSlides: 1,
        speed: 1000,
        loop: true,
        allowTouchMove: false,
        navigation: {
          nextEl: ".js-campaign-next",
          prevEl: ".js-campaign-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          // 767px以上の場合
          767: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        }
      });
    }
    
    // ナビゲーションボタンの表示を制御する関数
    function toggleNavigationButtons() {
      const slides = document.querySelectorAll('.campaign-swiper .swiper-slide');
      const nextButton = document.querySelector('.js-campaign-next');
      const prevButton = document.querySelector('.js-campaign-prev');

      console.log(slides.length);
    
      if (slides.length <= 4) {
        nextButton.style.display = 'none';
        prevButton.style.display = 'none';
      } else {
        nextButton.style.display = '';
        prevButton.style.display = '';
      }
    }
    
    // ウィンドウのリサイズ時にSwiperを初期化または破棄
    function handleResize() {
      if (window.innerWidth > 767) {
        toggleNavigationButtons(); // ナビゲーションボタンの表示を切り替える
        if (!campaignSwiper) {
          initSwiper(); // Swiperを初期化
        }
      } else {
        if (campaignSwiper) {
          campaignSwiper.destroy(true, true); // Swiperを破棄
          campaignSwiper = null; // インスタンスをリセット
        }
      }
    
    }
    
    // 初期化
    handleResize();
    window.addEventListener('resize', handleResize);
    
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FixBanner {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    var fixedBanner = $(".c-fixedBanner");
    var footer = $(".l-footer");

    if(fixedBanner) {
      // Closeボタンが押されたときの処理
      $(".c-fixedBanner__close").click(function() {
          fixedBanner.addClass("is-hidden");
      });
  
      // スクロール時の処理
      $(window).scroll(function() {
          var footerOffsetTop = footer.offset().top;
          var fixedBannerOffsetTop = fixedBanner.offset().top;
  
          // FixedBannerがFooterに到達したときの処理
          if (fixedBannerOffsetTop + fixedBanner.height() >= footerOffsetTop) {
              fixedBanner.addClass("is-hidden");
          }
      });
    }
  }
}



class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // フォーム二重送信対策
    $('.submit-btn').click(function() {
      $(this).css({'pointerEvents':'none'});
    })
  }
}

//noScroll
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

//noScroll
class HeaderAdjust {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var topHeader = document.querySelector(".top-header");
    if (topHeader) {
        document.querySelector('.js-megaMenu_shop').classList.add("is-topPage");
        topHeader.classList.add("is-topPage");
        document.querySelector(".l-header__menu").classList.add("is-block");
        const megaTrigger = document.querySelectorAll(".js-megaTrigger-click");
        megaTrigger.forEach(function(el) {
          el.classList.add("is-topPage");
        });
        document.querySelector(".mega-Service").classList.add("is-topPage");
        document.querySelector(".mega-tel").classList.add("is-topPage");
        document.querySelector(".mega-line").classList.add("is-topPage");
        document.querySelector(".header-contact").classList.add("is-topPage");
    }
  }
}
//noScroll
class HeaderHumburger {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const btn = document.querySelector(".js-hum");
    const menu = document.querySelector(".spMenu");
    const html = document.querySelector("html");
    
    btn.addEventListener("click", () => {
      btn.classList.toggle("is-active");
      menu.classList.toggle("is-active");
      html.classList.toggle("is-hidden");
    })
  }
}
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

//noScroll
class LoadingEvent {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
    
    // クッキーの設定
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/`;
    }
    
    if (!getCookie("loading")) {
      setCookie("loading", "true", 1);
    
      gsap.to(".c-loading__content-top", { 
        x: "0%", 
        duration: 0.2, 
        delay: 0.4,
        onComplete: function() {
          document.querySelectorAll('.c-loading__content-top').forEach(function(content) {
            content.classList.add('is-active');
          });
        }
      });
    
      gsap.to(".c-loading__content-bottom", {
        x: "0%",
        duration: 0.2,
        delay: 0.4,
        onComplete: function() {
          document.querySelectorAll('.c-loading__content-bottom').forEach(function(content) {
            content.classList.add('is-active');
          });
        }
      });
    
      gsap.to(".c-loading__tire", { 
        duration: 0.3, 
        delay: 0.4 + 0.3,
        onComplete: function() {
          document.querySelectorAll('.c-loading__tire').forEach(function(tire) {
            tire.classList.add('is-active');
          });
        }
      });
    
      gsap.to(".c-loading__content-top", { 
        x: "-200%", 
        duration: 0.3, 
        delay: 2 
      });
    
      gsap.to(".c-loading__content-bottom", {
        x: "200%",
        duration: 0.3,
        delay: 2,
      });
    
      gsap.to(".c-loading__tire", { 
        duration: 0.3, 
        delay: 1.7, 
        onComplete: function() {
          document.querySelectorAll('.c-loading__tire').forEach(function(tire) {
            tire.classList.remove('is-active');
          });
        }
      });
    
      gsap.to(".c-loading", { 
        delay: 2, 
        onComplete: function() {
          document.querySelector('.c-loading').classList.add('is-hidden');
          // アニメーションが完了したことをローカルストレージに保存
          setCookie("loading", "true", 0.01);
          // .js-news-modalをフェードイン
          $('.js-news-modal').addClass('is-active');
        }
      });
      
    } else {
      document.querySelector('.c-loading').classList.add('is-hidden');
    }
    
  }
}

//noScroll
class MegaMenu {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // サービスを知る
    const megaMenu = document.querySelector(".js-megaMenu");
    const megaTrigger = document.querySelector(".js-megaTrigger");
    // 店舗に電話、LINE追加
    const megaTriggerClick = document.querySelectorAll(".js-megaTrigger-click");
    const megaMenuClick = document.querySelectorAll(".js-megaMenu-click");
    const overlay = document.querySelector(".overlay");
    const header = document.querySelector(".l-header");
    // メガメニュー以外のリンクを取得
    const headerLink = document.querySelectorAll(".header-link");

    // サービスを知る
    function handleMouseover() {
      megaMenu.classList.add('is-open');
      megaTrigger.classList.add('is-active');
      overlay.classList.add('is-active');
      header.classList.add('shadow-hidden');
      megaMenuClick.forEach(element => {
        element.classList.remove('is-open');
      });
    }
    function handleMouseleave() {
      megaMenu.classList.remove('is-open');
      megaTrigger.classList.remove('is-active');
      overlay.classList.remove('is-active');
      header.classList.remove('shadow-hidden');
    }
    megaTrigger.addEventListener('mouseover', handleMouseover);
    megaMenu.addEventListener('mouseover', handleMouseover);
    megaTrigger.addEventListener('mouseleave', handleMouseleave);
    megaMenu.addEventListener('mouseleave', handleMouseleave);

    // 店舗案内
    function handleMouseover_shop() {
      megaMenu_shop.classList.add('is-open');
      megaTrigger_shop.classList.add('is-active');
      overlay.classList.add('is-active');
      header.classList.add('shadow-hidden');
      megaMenuClick.forEach(element => {
        console.log(element);
        element.classList.remove('is-open');
      });
    }
    function handleMouseleave_shop() {
      megaMenu_shop.classList.remove('is-open');
      megaTrigger_shop.classList.remove('is-active');
      overlay.classList.remove('is-active');
      header.classList.remove('shadow-hidden');
    }
    // サービスを知る
    const megaMenu_shop = document.querySelector(".js-megaMenu_shop");
    const megaTrigger_shop = document.querySelector(".js-megaTrigger_shop");
    megaTrigger_shop.addEventListener('mouseover', handleMouseover_shop);
    megaMenu_shop.addEventListener('mouseover', handleMouseover_shop);
    megaTrigger_shop.addEventListener('mouseleave', handleMouseleave_shop);
    megaMenu_shop.addEventListener('mouseleave', handleMouseleave_shop);

    // // 店舗案内
    // function handleMouseover_access() {
    //   megaMenu_access.classList.add('is-open');
    //   megaTrigger_access.classList.add('is-active');
    //   overlay.classList.add('is-active');
    //   header.classList.add('shadow-hidden');
    //   megaMenuClick.forEach(element => {
    //     console.log(element);
    //     element.classList.remove('is-open');
    //   });
    // }
    // function handleMouseleave_access() {
    //   megaMenu_access.classList.remove('is-open');
    //   megaTrigger_access.classList.remove('is-active');
    //   overlay.classList.remove('is-active');
    //   header.classList.remove('shadow-hidden');
    // }

    // // 店舗案内
    // const megaMenu_access = document.querySelector(".js-megaMenu_access");
    // const megaTrigger_access = document.querySelector(".js-megaTrigger_access");
    // megaTrigger_access.addEventListener('mouseover', handleMouseover_access);
    // megaMenu_access.addEventListener('mouseover', handleMouseover_access);
    // megaTrigger_access.addEventListener('mouseleave', handleMouseleave_access);
    // megaMenu_access.addEventListener('mouseleave', handleMouseleave_access);

    
    megaTriggerClick.forEach(triggerItem => {
      triggerItem.addEventListener('mouseover', () => {

        // 他のtriggerItemからis-activeを除去
        megaTriggerClick.forEach(item => {
          if (item !== triggerItem) {
            item.classList.remove('is-active');
          }
        });
        megaMenuClick.forEach(menu => {
          if (menu !== triggerItem) {
            menu.classList.remove('is-active');
          }
        });

        // トリガーのdata属性を取得
        const triggerNum = triggerItem.getAttribute("data-num");

        megaMenuClick.forEach(menu => {
          // メニューのdata属性を取得
          const menuNum = menu.getAttribute("data-index");

          if (triggerNum === menuNum) {
            menu.classList.add('is-open');
            triggerItem.classList.add("is-active");
            overlay.classList.add("is-active");
            header.classList.add("shadow-hidden");

            triggerItem.addEventListener('mouseover', () => {
              triggerItem.classList.add("is-active");
            });

            menu.addEventListener('mouseover', () => {
              menu.classList.add('is-open');
              overlay.classList.add("is-active");
            });

            menu.addEventListener('mouseout', () => {
              menu.classList.remove('is-open');
              overlay.classList.remove("is-active");
            });
            
            [menu, triggerItem, overlay].forEach(ele => {
              ele.addEventListener('click', () => {
                menu.classList.remove('is-open');
                triggerItem.classList.remove("is-active");
                overlay.classList.remove("is-active");
                header.classList.remove("shadow-hidden");
              });
            });
          } else {
            menu.classList.remove("is-open");
          }
        });

        headerLink.forEach(headerLinkItem => {
          
          headerLinkItem.addEventListener('mouseover', () => {
            megaMenuClick.forEach(menu => {
              menu.classList.remove('is-open');
            });
          
            megaTriggerClick.forEach(triggerItem => {
              triggerItem.classList.remove("is-active");
            });
          
            overlay.classList.remove("is-active");
            header.classList.remove("shadow-hidden");
          });
        });

      });
    });

    // スクロール時にクラスを外す記述
    // window.addEventListener('scroll', () => {
    //   if (megaMenu.classList.contains('is-open') || megaTrigger.classList.contains('is-active') || overlay.classList.contains('is-active')) {
    //     megaMenu.classList.remove('is-open');
    //     megaTrigger.classList.remove('is-active');
    //     overlay.classList.remove('is-active');
    //     header.classList.remove('shadow-hidden');
    //   }
    //   megaTriggerClick.forEach(triggerItem => {
    //     triggerItem.classList.remove("is-active");
    //   });

    //   megaMenuClick.forEach(menu => {
    //     menu.classList.remove('is-open');
    //   });
    // });
  }
}

//noScroll
class ModalEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // s-movie__leftまたはs-movie__rightをクリックしたときの処理
    document.querySelectorAll('.s-movie__left, .s-movie__right').forEach(function(item) {
      item.addEventListener('click', function() {
        var modalContent = this.classList.contains('s-movie__left') ? '.s-movie__modal-content-01' : '.s-movie__modal-content-02';
        openModal(modalContent);
      });
    });

    // s-movie__modal-closeまたはoverlayをクリックしたときの処理
    document.querySelectorAll('.s-movie__modal-close, .overlay').forEach(function(item) {
      item.addEventListener('click', closeModal);
    });

    // モーダルを開く関数
    function openModal(contentSelector) {
      var modal = document.querySelector('.s-movie__modal');
      var overlay = document.querySelector('.overlay');
      var content = document.querySelector(contentSelector);
      var video_content = content.querySelector('iframe').contentWindow;

      [modal, overlay, content].forEach(function(item) {
        item.classList.add('is-modal');
      });

      video_content.postMessage('{"event":"command","func":"playVideo","args":null}', '*');
    }

    // モーダルを閉じる関数
    function closeModal() {
      var modal = document.querySelector('.s-movie__modal');
      var overlay = document.querySelector('.overlay');
      var contents = document.querySelectorAll('.s-movie__modal-content');
      var video_contents = modal.querySelectorAll('iframe');

      [modal, overlay].forEach(function(item) {
        item.classList.remove('is-modal');
      });

      contents.forEach(function(content) {
        content.classList.remove('is-modal');
        var video = content.querySelector('video');
      });

      video_contents.forEach(function(content) {
        var video_content = content.contentWindow;
        video_content.postMessage('{"event":"command","func":"pauseVideo","args":null}', '*');
      });
    }


  }
}

//noScroll
class NavToggle {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {

    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0){
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().siblings().removeClass('is-active')
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().addClass('is-active')
        } else {
          $(`.js-nav-target [href="#${$(item).attr('id')}"]`).parent().removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })

    $(".js-nav-target a").click(function() {
      setTimeout(() => {
        $(this).siblings().removeClass('is-active')
        $(this).addClass('is-active')
      }, 600)
    })
  }
}
class NewsModal {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const cookieName = "newsModalDisplayed";

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      return parts.length === 2 ? parts.pop().split(';').shift() : undefined;
    }
    
    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    
    if ($('.js-news-modal').length > 0) {
    
      $('.js-modal-close').on('click', function() {
          $('.js-news-modal').removeClass('is-active');
      });
    }
    
  }
}
class PageNavi {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // 前のページリンクの処理
    var prevLink = document.querySelector('.previouspostslink');
    if (prevLink) {
        var prevSpan = document.createElement('span');
        prevLink.appendChild(prevSpan);
    }

    // 次のページリンクの処理
    var nextLink = document.querySelector('.nextpostslink');
    if (nextLink) {
        var nextSpan = document.createElement('span');
        nextLink.appendChild(nextSpan);
    }
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class ScrollTop {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const toTopButton = document.querySelector(".s-contact__toTop-president");

    toTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', 
      });
    });

  }
}
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    const urlHash = location.hash;
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        const target = $(urlHash);
        const position = target.offset().top;
        $('body,html').stop().animate({
          scrollTop: position
        }, 500);
      }, 100);
    }

    $('a[href^="#"]').click(function(){
      const href= $(this).attr("href");
      const target = $(href);
      const position = target.offset().top;
      $('body,html').stop().animate({
        scrollTop: position
      }, 500);
      return false;
    });

    $('a[href*="#"]').click(function(){
      const btn = document.querySelector(".js-hum");
      const menu = document.querySelector(".spMenu");
      const html = document.querySelector("html");
    
      btn.classList.remove("is-active");
      menu.classList.remove("is-active");
      html.classList.remove("is-hidden");
    });
  }
}

class SwiperEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    var swiper01 = new Swiper('.c-swiper-01', {
      slidesPerView: 1.2,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        // disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 3.1,
          spaceBetween: 16,
        }
      }
    });

    var swiper02 = new Swiper('.c-swiper-02', {
      slidesPerView: 1.2,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        // disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        //767px以上の場合
        767: {
          slidesPerView: 3.1,
          spaceBetween: 16,
        }
      }
    });
  }
}

class TabChange {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // const triggers = document.querySelectorAll(".s-profile__right-trigger");
    // const tabs = document.querySelectorAll(".s-profile__right-tab");
  
    // triggers.forEach(trigger => {
    //   trigger.addEventListener("click", () => {
    //     const triggerNum = trigger.getAttribute("data-num");

    //     triggers.forEach(el => el.classList.remove("is-active"));
    //     trigger.classList.add("is-active");
          
    //     tabs.forEach(tab => tab.classList.remove("is-active"));
    //     tabs.forEach(tab => {
    //       const tabNum = tab.getAttribute("data-tab");
    //       if (triggerNum === tabNum) {
    //         tab.classList.add("is-active");
    //       }
    //     });
    //   });
    // });

    $('.s-profile__right-trigger').click(function() {
      $(this).addClass('is-active');
      $(this).siblings().removeClass('is-active');

      $('.s-profile__right-tab').css({'display': 'none'});
      $('.s-profile__picture').css({'display': 'none'});
      $('.s-profile__right-tab').eq($(this).index()).fadeIn();
      $('.s-profile__picture').eq($(this).index()).fadeIn(1);
    })

  }
}

//noScroll
class TableSpScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let el = $('<div class="sp c-table-scroll__trigger js-table-scroll-trigger"></div>')
    $('.js-table-scroll').append(el);

    // -----------------------------------
    // 沿革 横スクロール
    // -----------------------------------

    var scrollInterval;

    $('.js-table-scroll-trigger').on('mousedown touchstart', function() {
      console.log($(this).prev());
      var $container = $(this).prev();
      startScrolling($container, 'right');
    });

    $(document).on('mouseup touchend touchcancel', stopScrolling);

    function startScrolling($container, direction) {
      var scrollAmount = 2; // スクロール量をピクセル単位で設定

      scrollInterval = setInterval(function() {
        if (direction === 'right') {
          $container.scrollLeft($container.scrollLeft() + scrollAmount);
        } else {
          $container.scrollLeft($container.scrollLeft() - scrollAmount);
        }
      }, 1); // 50ミリ秒ごとにスクロール
    }

    function stopScrolling() {
      clearInterval(scrollInterval);
    }
  }
}


(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let formConvert = new FormConvert('js-convert');
  let megaMenu = new MegaMenu('js-megaMenu');
  let accordionEvent = new AccordionEvent('js-header');
  let navToggle = new NavToggle("js-nav-target");
  let smoothScroll = new SmoothScroll();
  let headerHumburger = new HeaderHumburger("js-header");
  let headerAdjust = new HeaderAdjust("js-header");
  let scrollTop = new ScrollTop("s-contact__toTop-president");
  let fixBanner = new FixBanner("c-fixedBanner");
  let newsModal = new NewsModal('js-news-modal');
  let loadingEvent = new LoadingEvent("c-loading");
  let facility = new Facility('p-facility');
  let swiperEvent = new SwiperEvent('swiper');
  let pageNavi = new PageNavi('c-pager');
  let tabChange = new TabChange('js-tabChange');
  let modalEvent = new ModalEvent('js-modal');
  let formCheckbox = new FormCheckbox('mw_wp_form_confirm');
  let tableSpScroll = new TableSpScroll('js-table-scroll');
  let campaignSwiper = new CampaignSwiper();
  
  // ページ
  let frontPage = new FrontPage("p-top");
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });